import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorOneClickBuy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M1.25 5.5A2.25 2.25 0 0 1 3.5 3.25h15a2.25 2.25 0 0 1 2.25 2.25v1.654h-1.5V5.5a.75.75 0 0 0-.75-.75h-15a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h5.912v1.5H3.5a2.25 2.25 0 0 1-2.25-2.25v-11Z"
    />
    <path
      fill="#F7A600"
      d="M6 7.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H6Zm16.487 1.292.134.532c.288 1.114.034 2.603-.57 4.046a11.903 11.903 0 0 1-2.803 4.03c-.047 1.18-.536 2.152-1.45 3.082l-.794.809-1.616-2.475c-.714.076-1.467-.254-1.985-.78-.523-.533-.846-1.306-.76-2.042l-2.397-1.64.791-.805c.892-.909 1.842-1.4 2.984-1.46a11.527 11.527 0 0 1 3.96-2.862c1.422-.614 2.888-.868 3.981-.574l.525.139Zm-1.246 1.265c-.654-.062-1.603.098-2.679.563a10.034 10.034 0 0 0-3.637 2.712l-.23.273-.352-.008a2.629 2.629 0 0 0-1.727.555l1.872 1.282-.328.606c-.072.134-.085.54.294.925.382.389.784.374.901.31l.597-.328 1.258 1.926c.421-.578.576-1.133.553-1.786l-.012-.362.268-.237a10.368 10.368 0 0 0 2.665-3.71c.457-1.095.617-2.058.557-2.721ZM18.805 13a.744.744 0 0 0 .737-.75c0-.414-.33-.75-.737-.75a.744.744 0 0 0-.737.75c0 .414.33.75.737.75Zm-8.84 8.168s1.985-.347 2.732-1.122c.566-.589.669-1.444.204-1.926-.464-.482-1.287-.375-1.853.213-.67.695-1.082 2.835-1.082 2.835Z"
    />
  </svg>
);
export default SvgTwoColorOneClickBuy;
